import React, { useState, useEffect, useRef } from "react";
import { Col, Row, Table } from "antd";
import { getColumnSearchProps } from "../general/FilterHeaderColumn";

import * as XLSX from 'xlsx/xlsx.mjs';

import 'antd/dist/antd.css'; // or 'antd/dist/antd.less'

import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';

import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { FileUpload } from 'primereact/fileupload';
import { InputSwitch } from 'primereact/inputswitch';
import { InputText } from 'primereact/inputtext';
import { Tag } from 'primereact/tag';
import Swal from "sweetalert2";
import "animate.css";

import Popup from "reactjs-popup";
import "reactjs-popup/dist/index.css";
import app from "../../firebase-config";
import Registro from "../Modal/Registro";
import EditarUsuario from "../Modal/EditarUsuario";
import moment from "moment/moment";
import MessagesUtil from "../../util/Messages.util";
import { Toast } from "primereact/toast";

export default function Usuarios() {
  const myToast = useRef(null);
  const excelInputRef = useRef(null);
  const [loading, setLoading] = useState(false);

  const [users, setUsers] = useState([]);
  const [allUsers, setAllUsers] = useState([]);
  const [usersLoaded, setUsersLoaded] = useState(false);
  const [usuario, setUsuario] = useState([]);
  const [globalSearch, setGlobalSearch] = useState("");
  const [statusFilter, setStatusFilter] = useState("all");
  const [roleFilter, setRoleFilter] = useState("all");
  const [excelFileName, setExcelFileName] = useState("");
  const [excelValidUsers, setExcelValidUsers] = useState([]);
  const [excelErrors, setExcelErrors] = useState([]);
  const [excelPreviewRows, setExcelPreviewRows] = useState([]);
  const [excelTotalRows, setExcelTotalRows] = useState(0);

  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");

  const [visibleModalNuevo, setVisibleModalNuevo] = useState(false);
  const [visibleModalEditar, setVisibleModalEditar] = useState(false);
  const [visibleModalImportar, setVisibleModalImportar] = useState(false);

  const primeButtonStyle = { borderRadius: 8 };

  const columns = [{
    title: "Persona",
    key: "persona",
    fixed: "left",
    width: 230,
    ...getColumnSearchProps(
      "personaSearch",
      "Persona",
      searchedColumn,
      setSearchedColumn,
      searchText,
      setSearchText
    ),
    render: (_, row) => {
      const fullName = [row.nombres, row.apellidos].filter(Boolean).join(" ").trim();
      return (
        <div
          className="text-left"
          style={{
            fontWeight: 700,
            color: "#263238",
            lineHeight: "18px",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
          title={fullName || "-"}
        >
          {fullName || "-"}
        </div>
      );
    },
  },
  {
    title: "Documento",
    key: "documento",
    align: "center",
    width: 155,
    ...getColumnSearchProps(
      "documentoSearch",
      "Documento",
      searchedColumn,
      setSearchedColumn,
      searchText,
      setSearchText
    ),
    render: (_, row) => (
      <div style={{ lineHeight: "18px" }}>
        <Tag value={row.tipoDoc || "-"} severity="info" />
        <span style={{ marginLeft: 6, fontWeight: 600 }}>{row.nroDoc || "-"}</span>
      </div>
    ),
  },
  {
    title: "Correo",
    key: "email",
    dataIndex: "email",
    width: 240,
    ...getColumnSearchProps(
      "email",
      "Correo",
      searchedColumn,
      setSearchedColumn,
      searchText,
      setSearchText
    ),
    render: (text) => (
      <span className="text-break">
        <i className="pi pi-envelope mr-2 text-muted"></i>
        {text || "-"}
      </span>
    ),
  },
  {
    title: "Empresa",
    key: "empresa",
    dataIndex: "empresa",
    width: 190,
    ...getColumnSearchProps(
      "empresa",
      "Empresa",
      searchedColumn,
      setSearchedColumn,
      searchText,
      setSearchText
    ),
    render: (text) => text || "-",
  },
  {
    title: "Última Conexión",
    dataIndex: "lastConnection",
    key: "lastConnection",
    align: "center",
    width: 175,
    ...getColumnSearchProps(
      "lastConnection",
      "Última Conexión",
      searchedColumn,
      setSearchedColumn,
      searchText,
      setSearchText
    ),
    render: (text) => {
      if (!text) return "-"
      const millis =
        text.seconds * 1000 +
        text.nanoseconds / 1e6;
      const formatted = moment(millis).format("DD/MM/YYYY HH:mm");
      return formatted
    },
  },
  {
    title: "Estado",
    dataIndex: "estado",
    key: "estado",
    width: 85,
    align: "center",
    filters: [
      { text: "Habilitado", value: "enabled" },
      { text: "Deshabilitado", value: "disabled" },
      { text: "Pendiente", value: "pending" },
    ],
    onFilter: (value, record) => record.estado === value,
    render: (_, row) => {
      const value = row.estado === "enabled" ? "Habilitado" : row.estado === "disabled" ? "Deshabilitado" : "Pendiente";
      const severity = row.estado === "enabled" ? "success" : row.estado === "disabled" ? "danger" : "warning";
      return <Tag value={value} severity={severity} />;
    },
  },
  {
    title: "Administrador",
    dataIndex: "tipoUsuario",
    key: "tipoUsuario",
    width: 125,
    align: "center",
    filters: [
      { text: "Administrador", value: "Administrador" },
      { text: "Normal", value: "Normal" },
    ],
    onFilter: (value, record) => record.tipoUsuario === value,
    render: (_, row) => {
      return (<InputSwitch
        onChange={() =>
          setAdmin(row.nombres, row.apellidos, row.tipoUsuario, row.idUserAuth)
        }
        checked={_ === "Administrador"} />);
    },
  },
  {
    title: "Acciones",
    dataIndex: "acciones",
    key: "acciones",
    width: 200,
    align: "center",
    fixed: "right",
    render: (_, row) => {
      return (
        <div className="row">
          <div className="col-sm-12 col-md-4">
            <Popup
              trigger={
                <button
                  id={row.idUserAuth}
                  onClick={(e) => {
                    llenarData(row.idUserAuth)
                    setVisibleModalEditar(true)
                  }}
                  className="btn btn-block bg-gradient-primary btn-sm"
                >
                  <i className="fas fa-edit"></i>
                </button>
              }
              position="top center"
              on={["hover", "focus"]}
            >
              <div>
                Editar Usuario
              </div>
            </Popup>
          </div>
          <div className="col-sm-12 col-md-4">
            {row.estado === "enabled" ? (
              <Popup
                trigger={
                  <button
                    id={row.idUserAuth}
                    className="btn btn-block bg-gradient-success btn-sm"
                  >
                    <i className="fas fa-check"></i>
                  </button>
                }
                position="right center"
              >
                <div className="row">
                  <div className="col-md-8">
                    ¿Deshabilitar al usuario?
                  </div>
                  <button
                    onClick={() =>
                      cambiarEstado(
                        row.estado,
                        row.idUserAuth
                      )
                    }
                    className="btn btn-danger mr-1 col-md-3"
                  >
                    <i className="fas fa-ban"></i>
                  </button>
                </div>
              </Popup>
            ) : row.estado === "disabled" ? (
              <Popup
                trigger={
                  <button
                    id={row.idUserAuth}
                    className="btn btn-block bg-gradient-danger btn-sm "
                  >
                    <i className="fas fa-ban"></i>
                  </button>
                }
                position="right center"
              >
                <div className="row">
                  <div className="col-md-8">
                    ¿Habilitar al usuario?
                  </div>
                  <button
                    onClick={() =>
                      cambiarEstado(
                        row.estado,
                        row.idUserAuth
                      )
                    }
                    className="btn btn-success mr-1 col-md-3"
                  >
                    <i className="fas fa-check"></i>
                  </button>
                </div>
              </Popup>
            ) : (
              <Popup
                trigger={
                  <button
                    id={row.idUserAuth}
                    className="btn btn-block bg-gradient-danger btn-sm "
                  >
                    <i className="fas fa-user-clock"></i>
                  </button>
                }
                position="right center"
              >
                <div className="row">
                  <div className="col-md-8">
                    ¿Habilitar al usuario?
                  </div>
                  <button
                    onClick={() =>
                      cambiarEstado(
                        row.estado,
                        row.idUserAuth
                      )
                    }
                    className="btn btn-danger mr-1 col-md-3"
                  >
                    <i className="fas fa-check"></i>
                  </button>
                </div>
              </Popup>
            )}
          </div>
          <div className="col-sm-12 col-md-4">
            <Popup
              trigger={
                <button
                  id={row.idUserAuth}
                  onClick={(e) =>
                    borrarUsuario(
                      row.nombres,
                      row.apellidos,
                      row.idUserAuth
                    )
                  }
                  className="btn btn-block bg-gradient-secondary btn-sm"
                >
                  <i className="far fa-trash-alt"></i>
                </button>
              }
              position="top center"
              on={["hover", "focus"]}
              arrow="center center"
            >
              <span className="ml-10">
                Eliminar Usuario
              </span>
            </Popup>
          </div>
        </div>
      );
    },
  },
  ];
  /***********Notification Toast************ */

  const excelRequiredFields = [
    "TIPODOC",
    "NRODOC",
    "NOMBRES",
    "APELLIDOS",
    "CARGO",
    "EMPRESA",
    "EMAIL",
    "PASSWORD",
  ];

  function resetExcelImport() {
    setExcelFileName("");
    setExcelValidUsers([]);
    setExcelErrors([]);
    setExcelPreviewRows([]);
    setExcelTotalRows(0);
    if (excelInputRef.current) {
      excelInputRef.current.clear();
    }
  }

  function descargarPlantillaExcel() {
    const rows = [
      {
        TIPODOC: "DNI",
        NRODOC: "12345678",
        NOMBRES: "Juan",
        APELLIDOS: "Perez Lopez",
        CARGO: "Operador",
        EMPRESA: "Empresa SAC",
        EMAIL: "juan.perez@empresa.com",
        PASSWORD: "123456",
      },
    ];
    const sheet = XLSX.utils.json_to_sheet(rows, { header: excelRequiredFields });
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, sheet, "Usuarios");
    XLSX.writeFile(workbook, "plantilla_usuarios.xlsx");
  }

  function validateExcelRows(rows) {
    const validUsers = [];
    const errors = [];
    const previewRows = [];
    const nroDocCounts = {};
    const emailCounts = {};
    const existingByNroDoc = {};
    const existingByEmail = {};

    allUsers.forEach((user) => {
      const nroDoc = user.nroDoc?.toString().trim();
      const email = user.email?.toString().trim().toLowerCase();

      if (nroDoc) existingByNroDoc[nroDoc] = user;
      if (email) existingByEmail[email] = user;
    });

    rows.forEach((user) => {
      const nroDoc = user.NRODOC?.toString().trim();
      const email = user.EMAIL?.toString().trim().toLowerCase();

      if (nroDoc) {
        nroDocCounts[nroDoc] = (nroDocCounts[nroDoc] || 0) + 1;
      }

      if (email) {
        emailCounts[email] = (emailCounts[email] || 0) + 1;
      }
    });

    rows.forEach((user, index) => {
      const normalizedUser = {
        TIPODOC: user.TIPODOC?.toString().trim(),
        NRODOC: user.NRODOC?.toString().trim(),
        NOMBRES: user.NOMBRES?.toString().trim(),
        APELLIDOS: user.APELLIDOS?.toString().trim(),
        CARGO: user.CARGO?.toString().trim(),
        EMPRESA: user.EMPRESA?.toString().trim(),
        EMAIL: user.EMAIL?.toString().trim().toLowerCase(),
        PASSWORD: user.PASSWORD?.toString().trim(),
      };
      const missingFields = excelRequiredFields.filter((field) => {
        const value = normalizedUser[field];
        return value === undefined || value === null || value.toString().trim() === "";
      });
      const nroDoc = normalizedUser.NRODOC;
      const email = normalizedUser.EMAIL;
      const duplicatedFields = [];
      const formatErrors = [];
      const existingByDoc = existingByNroDoc[nroDoc];
      const existingByMail = existingByEmail[email];
      let status = "new";
      let message = "Listo para crear";

      if (nroDoc && nroDocCounts[nroDoc] > 1) {
        duplicatedFields.push(`NRODOC ${nroDoc}`);
      }

      if (email && emailCounts[email] > 1) {
        duplicatedFields.push(`EMAIL ${email}`);
      }

      if (email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        formatErrors.push("EMAIL no tiene un formato valido");
      }

      if (normalizedUser.PASSWORD && normalizedUser.PASSWORD.length < 6) {
        formatErrors.push("PASSWORD debe tener al menos 6 caracteres");
      }

      if (missingFields.length > 0) {
        status = "error";
        message = `Faltan ${missingFields.join(", ")}`;
        errors.push(`Fila ${index + 2}: ${message}`);
      } else if (duplicatedFields.length > 0) {
        status = "error";
        message = `Repetido ${duplicatedFields.join(", ")}`;
        errors.push(`Fila ${index + 2}: ${message}`);
      } else if (formatErrors.length > 0) {
        status = "error";
        message = formatErrors.join(", ");
        errors.push(`Fila ${index + 2}: ${message}`);
      } else if (existingByDoc && existingByDoc.email?.toString().trim().toLowerCase() !== email) {
        status = "error";
        message = "NRODOC ya existe con otro EMAIL";
        errors.push(`Fila ${index + 2}: ${message}`);
      } else if (existingByMail && existingByMail.nroDoc?.toString().trim() !== nroDoc) {
        status = "error";
        message = "EMAIL ya pertenece a otro usuario";
        errors.push(`Fila ${index + 2}: ${message}`);
      } else {
        if (existingByDoc) {
          status = "update";
          message = "Se actualizara el usuario existente";
        }

        validUsers.push(normalizedUser);
      }

      previewRows.push({
        row: index + 2,
        nroDoc: nroDoc || "-",
        email: email || "-",
        nombres: normalizedUser.NOMBRES || "-",
        status,
        message,
      });
    });

    return { validUsers, errors, previewRows };
  }

  const ExcelAJSON = (e) => {
    const file = e.files?.[0] || e.target?.files?.[0];
    if (!file) return;
    setExcelFileName(file.name);

    const reader = new FileReader();

    reader.onerror = () => {
      console.error("Error al leer el archivo");
      MessagesUtil.showToast(myToast, "error", "Error", "No se pudo leer el archivo.");
    };

    reader.onload = (event) => {
      try {
        const workbook = XLSX.read(event.target.result);
        const firstSheetName = workbook.SheetNames[0];
        const sheet = workbook.Sheets[firstSheetName];

        if (!sheet) {
          MessagesUtil.showToast(myToast, "warn", "Archivo vacío", "El archivo no contiene hojas.");
          return;
        }

        let datos = XLSX.utils.sheet_to_json(sheet);

        if (datos.length === 0) {
          MessagesUtil.showToast(myToast, "warn", "Sin datos", "La hoja está vacía.");
          return;
        }

        if (!usersLoaded) {
          MessagesUtil.showToast(myToast, "warn", "Cargando usuarios", "Espere a que termine de cargar la lista de usuarios.");
          return;
        }

        const { validUsers, errors, previewRows } = validateExcelRows(datos);
        setExcelTotalRows(datos.length);
        setExcelValidUsers(validUsers);
        setExcelErrors(errors);
        setExcelPreviewRows(previewRows);

      } catch (err) {
        console.error("Error procesando Excel:", err);
        MessagesUtil.showToast(myToast, "error", "Error", "El Excel no es válido.");
      }
    };

    reader.readAsArrayBuffer(file);
  };

  async function importarRegistrosValidos() {
    if (excelValidUsers.length === 0) {
      MessagesUtil.showToast(myToast, "warn", "Sin registros", "No hay registros válidos para importar.");
      return;
    }

    await saveJsonUsers(excelValidUsers);
    setVisibleModalImportar(false);
    resetExcelImport();
  }


  async function saveJsonUsers(users) {
    let created = 0;
    let updated = 0;
    let errs = 0;
    let errorDnis = [];
    let rowErrors = [];

    const crearUsuario = app.functions().httpsCallable("crearUsuario");
    const existingByNroDoc = {};

    allUsers.forEach((existingUser) => {
      const nroDoc = existingUser.nroDoc?.toString().trim();
      if (nroDoc) existingByNroDoc[nroDoc] = existingUser;
    });

    Swal.fire({
      title: "Registrando Usuarios",
      html: `Cargando usuario 1 de ${users.length}. Espere, por favor.`,
      didOpen: () => Swal.showLoading(),
      allowOutsideClick: false,
    });

    for (let i = 0; i < users.length; i++) {
      const user = users[i];

      // Validación
      if (
        !user.TIPODOC ||
        !user.NRODOC ||
        !user.NOMBRES ||
        !user.APELLIDOS ||
        !user.CARGO ||
        !user.EMPRESA ||
        !user.EMAIL ||
        !user.PASSWORD
      ) {
        errs++;
        if (user.NRODOC) errorDnis.push(user.NRODOC.toString());
        rowErrors.push(`Fila ${i + 2}${user.NRODOC ? ` (${user.NRODOC})` : ""}: datos incompletos`);
        continue;
      }

      try {
        const usuariosRef = app.firestore().collection("users");
        const existingUser = existingByNroDoc[user.NRODOC.toString()];

        Swal.update({
          html: `Cargando usuario ${i + 1} de ${users.length}. Espere, por favor.`
        });

        if (existingUser && !existingUser.idUserAuth) {
          throw new Error("El usuario ya existe, pero no tiene idUserAuth para actualizar");
        }

        if (existingUser?.idUserAuth) {
          // Usuario encontrado → actualizar solo uno (debería ser único)
          await usuariosRef.doc(existingUser.idUserAuth).update({
            nombres: user.NOMBRES,
            apellidos: user.APELLIDOS,
            cargo: user.CARGO,
            empresa: user.EMPRESA,
          });

          updated++;
        } else {
          // Crear usuario
          await crearUsuario({
            tipoDoc: user.TIPODOC,
            nroDoc: user.NRODOC.toString(),
            nombres: user.NOMBRES,
            apellidos: user.APELLIDOS,
            cargo: user.CARGO,
            empresa: user.EMPRESA,
            email: user.EMAIL,
            password: user.PASSWORD.toString(),
            estado: "enabled",
            connected: false,
            tipoUsuario: "Normal",
            token: "",
          });
          console.log(crearUsuario);
          created++;
        }

      } catch (e) {
        const message = e.details || e.message || "Error desconocido";
        errs++;
        if (user.NRODOC) errorDnis.push(user.NRODOC.toString());
        rowErrors.push(`Fila ${i + 2}${user.NRODOC ? ` (${user.NRODOC})` : ""}: ${message}`);
      }
    }

    // Solo una vez al final
    showCompleteDialog(users.length, users.length, created, updated, errs, errorDnis, rowErrors);
  }

  function showCompleteDialog(i, size, created, updated, errs, errorDnis = [], rowErrors = []) {
    if (i === size) {
      const dnisConError = errorDnis.length
        ? "<br/><br/><b>DNIs con error:</b><br/>" + errorDnis.join("<br/>")
        : "";
      const detalleErrores = rowErrors.length
        ? "<br/><br/><b>Detalle de errores:</b><br/>" + rowErrors.slice(0, 20).join("<br/>") + (rowErrors.length > 20 ? "<br/>..." : "")
        : "";

      Swal.close()
      Swal.fire(
        {
          title: "Excel Importado",
          html: "Usuarios creados: " + created + ".<br/>Usuarios actualizados: " + updated + ".<br/>Errores: " + errs + dnisConError + detalleErrores,
          icon: "info"
        });
    }
  }

  function confirmDialog(nombres, apellidos, id) {
    Swal.fire({
      title: "Eliminar usuario:\n" + nombres + " " + apellidos,
      text:
        "Si confirma, eliminará todos los datos del usuario. ¿Está seguro de continuar?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Eliminar",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.isConfirmed) {
        spinnerModal();
        const borrarUser = app.functions().httpsCallable("borrarUsuario");
        borrarUser({ idUserAuth: id })
          .then(() => {
            Swal.fire("Eliminado!", "El usuario ha sido eliminado.", "success");
          })
          .catch((e) => {
            console.log(e)
            Swal.fire("Error!", "No se pudo eliminar al usuario.", "error");
          });
      }
    });
  }

  function spinnerModal() {
    Swal.fire({
      title: "Procesando registro",
      html: "Espere un momento por favor.",
      didOpen: () => {
        Swal.showLoading();
      }
    });
  }

  function getData() {
    return app
      .firestore()
      .collection("users")
      .orderBy("nombres", "asc")
      .onSnapshot((snap) => {
        const docs = [];
        snap.forEach((doc) => {
          const data = doc.data();
          docs.push({
            ...data,
            personaSearch: [data.nombres, data.apellidos].filter(Boolean).join(" "),
            documentoSearch: [data.tipoDoc, data.nroDoc].filter(Boolean).join(" "),
          });
        });
        setAllUsers(docs);
        setUsers(docs);
        setUsersLoaded(true);
        setLoading(false);
      });
  }

  function llenarData(id) {
    if (id) {
      app
        .firestore()
        .collection("users")
        .doc(id)
        .get()
        .then((snap) => setUsuario(snap.data()));
    }
  }

  function cambiarEstado(estado, id) {
    if (estado === "enabled") {
      app
        .firestore()
        .collection("users")
        .doc(id)
        .update({ estado: "disabled" });
    }
    if (estado === "disabled") {
      app.firestore().collection("users").doc(id).update({ estado: "enabled" });
    }
    if (estado === "pending") {
      app.firestore().collection("users").doc(id).update({ estado: "enabled" });
    }
  }

  function borrarUsuario(nombres, apellidos, id) {
    confirmDialog(nombres, apellidos, id);
  }

  function setAdmin(nombres, apellidos, tipoUsuario, id) {
    const admin = tipoUsuario === "Administrador";
    Swal.fire({
      title: admin ? "Retirar privilegios de administrador a:\n" + nombres + " " + apellidos : "Proporcionar privilegios de administrador a:\n" + nombres + " " + apellidos,
      text: admin ? "Si confirma, el usuario ya no tendrá acceso al sistema como administrador ¿Está seguro de continuar?" : "Si confirma, el usuario tendrá acceso al sistema como administrador ¿Está seguro de continuar?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: admin ? "Quitar privilegios" : "Dar privilegios",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.isConfirmed) {
        spinnerModal();
        app
          .firestore()
          .collection("users")
          .doc(id)
          .update({ tipoUsuario: admin ? "Normal" : "Administrador" })
          .then(() => {
            Swal.fire("¡Listo!", admin ? "El usuario ya no es administrador." : "El usuario ahora es administrador.", "success");
          })
          .catch(() => {
            Swal.fire("Error!", "No se pudo actualizar al usuario.", "error");
          });
      }
    });
  }

  function buscar(e) {
    setGlobalSearch(e);
  }

  useEffect(() => {
    const unsubscribe = getData();
    //notificationState();
    return () => unsubscribe();
  }, []);

  useEffect(() => {
    const value = globalSearch.trim().toLowerCase();
    const filtered = allUsers.filter((user) => {
      const matchesStatus = statusFilter === "all" || user.estado === statusFilter;
      const matchesRole = roleFilter === "all" || user.tipoUsuario === roleFilter;
      const matchesSearch =
        !value ||
        [
          user.nombres,
          user.apellidos,
          user.cargo,
          user.empresa,
          user.tipoDoc,
          user.nroDoc,
          user.idUserAuth,
          user.email,
          user.tipoUsuario,
        ].some((field) => field?.toString().toLowerCase().includes(value));

      return matchesStatus && matchesRole && matchesSearch;
    });

    setUsers(filtered);
  }, [allUsers, globalSearch, statusFilter, roleFilter]);

  const totalUsers = allUsers.length;
  const enabledUsers = allUsers.filter((user) => user.estado === "enabled").length;
  const disabledUsers = allUsers.filter((user) => user.estado === "disabled").length;
  const pendingUsers = allUsers.filter((user) => user.estado === "pending").length;
  const adminUsers = allUsers.filter((user) => user.tipoUsuario === "Administrador").length;

  const excelNewCount = excelPreviewRows.filter((row) => row.status === "new").length;
  const excelUpdateCount = excelPreviewRows.filter((row) => row.status === "update").length;

  const usuarios = (
    <>
      <div className="content-wrapper">
        {/* Content Header (Page header) */}
        <div className="content-header">
          <div className="container">
            <div className="row mb-2">
              <div className="col-sm-6">
                <h1 className="m-0 text-dark">
                  {" "}
                  {/*Top Navigation*/} <small></small>
                </h1>
              </div>
              {/* /.col */}
              {/* /.col */}
            </div>
            {/* /.row */}
          </div>
          {/* /.container-fluid */}
        </div>
        {/* /.content-header */}
        {/* Main content */}
        <section className="container">
          <div className="content">
            <div className="row">
              {/* /.col-md-6 */}
              <div className="col-12">
                <div className="card" style={{ border: "1px solid #e7edf3", boxShadow: "0 10px 30px rgba(15, 23, 42, 0.06)" }}>
                  <div className="card-header" style={{ backgroundColor: "#ffffff", borderBottom: "1px solid #edf2f7", padding: 20 }}>
                    <Row gutter={[16, 16]} align="middle">
                      <Col xs={24} lg={12}>
                        <div className="d-flex align-items-center" style={{ gap: 12 }}>
                          <span
                            className="d-inline-flex align-items-center justify-content-center"
                            style={{
                              width: 46,
                              height: 46,
                              borderRadius: 8,
                              backgroundColor: "#e8f5e9",
                              color: "#2e7d32",
                            }}
                          >
                            <i className="pi pi-users" style={{ fontSize: 22 }}></i>
                          </span>
                          <div>
                            <h3 className="mb-0" style={{ fontSize: 22, fontWeight: 700, color: "#263238" }}>Usuarios</h3>
                            <small className="text-muted">Gestiona accesos, estados, administradores e importaciones.</small>
                          </div>
                        </div>
                      </Col>
                      <Col xs={24} lg={12}>
                        <div className="d-flex flex-wrap justify-content-lg-end" style={{ gap: 8 }}>
                          <Button
                            type="button"
                            label="Agregar usuario"
                            icon="pi pi-user-plus"
                            severity="success"
                            style={primeButtonStyle}
                            onClick={() => setVisibleModalNuevo(true)}
                          />
                          <Button
                            type="button"
                            label={usersLoaded ? "Importar Excel" : "Cargando usuarios"}
                            icon="pi pi-file-excel"
                            severity="success"
                            outlined
                            disabled={!usersLoaded}
                            style={primeButtonStyle}
                            onClick={() => setVisibleModalImportar(true)}
                          />
                        </div>
                      </Col>
                    </Row>

                    <Row gutter={[12, 12]} style={{ marginTop: 18 }}>
                      {[
                        { label: "Total", value: totalUsers, icon: "pi pi-database", color: "#455a64", bg: "#eef3f7", active: statusFilter === "all" && roleFilter === "all", onClick: () => { setStatusFilter("all"); setRoleFilter("all"); } },
                        { label: "Habilitados", value: enabledUsers, icon: "pi pi-check-circle", color: "#2e7d32", bg: "#e8f5e9", active: statusFilter === "enabled", onClick: () => { setStatusFilter("enabled"); setRoleFilter("all"); } },
                        { label: "Deshabilitados", value: disabledUsers, icon: "pi pi-ban", color: "#c62828", bg: "#ffebee", active: statusFilter === "disabled", onClick: () => { setStatusFilter("disabled"); setRoleFilter("all"); } },
                        { label: "Pendientes", value: pendingUsers, icon: "pi pi-clock", color: "#f57f17", bg: "#fff8e1", active: statusFilter === "pending", onClick: () => { setStatusFilter("pending"); setRoleFilter("all"); } },
                        { label: "Administradores", value: adminUsers, icon: "pi pi-shield", color: "#1565c0", bg: "#e3f2fd", active: roleFilter === "Administrador", onClick: () => { setStatusFilter("all"); setRoleFilter("Administrador"); } },
                        { label: "Filtrados", value: users.length, icon: "pi pi-filter", color: "#6a1b9a", bg: "#f3e5f5", active: globalSearch || statusFilter !== "all" || roleFilter !== "all", onClick: () => { setGlobalSearch(""); setStatusFilter("all"); setRoleFilter("all"); } },
                      ].map((metric) => (
                        <Col xs={12} md={8} xl={4} key={metric.label}>
                          <div
                            className="h-100"
                            onClick={metric.onClick}
                            style={{
                              border: metric.active ? `2px solid ${metric.color}` : "1px solid #e8eef4",
                              borderRadius: 8,
                              padding: 14,
                              backgroundColor: metric.active ? metric.bg : "#ffffff",
                              cursor: "pointer",
                              transition: "border-color .15s ease, background-color .15s ease, transform .15s ease",
                            }}
                          >
                            <div className="d-flex align-items-center justify-content-between">
                              <div>
                                <small className="text-muted d-block">{metric.label}</small>
                                <strong style={{ fontSize: 24, color: "#263238" }}>{metric.value}</strong>
                              </div>
                              <span
                                className="d-inline-flex align-items-center justify-content-center"
                                style={{
                                  width: 38,
                                  height: 38,
                                  borderRadius: 8,
                                  color: metric.color,
                                  backgroundColor: metric.bg,
                                }}
                              >
                                <i className={metric.icon}></i>
                              </span>
                            </div>
                          </div>
                        </Col>
                      ))}
                    </Row>
                  </div>

                  <div style={{ padding: 16, borderBottom: "1px solid #edf2f7", backgroundColor: "#fbfcfd" }}>
                    <Row gutter={[12, 12]} align="middle">
                      <Col xs={24} lg={15}>
                        <div
                          className="d-flex align-items-center"
                          style={{
                            border: "1px solid #dbe5ee",
                            borderRadius: 6,
                            backgroundColor: "#ffffff",
                            padding: "0 10px",
                            minHeight: 44,
                            gap: 8,
                          }}
                        >
                          <i className="pi pi-search text-muted"></i>
                          <span className="w-100">
                            <InputText
                              value={globalSearch}
                              onChange={(e) => buscar(e.target.value)}
                              placeholder="Buscar nombre, documento, correo, empresa..."
                              className="w-100"
                              style={{ border: 0, boxShadow: "none", paddingLeft: 0 }}
                            />
                          </span>
                          {globalSearch && (
                            <Button
                              type="button"
                              icon="pi pi-times"
                              severity="secondary"
                              text
                              rounded
                              style={primeButtonStyle}
                              onClick={() => setGlobalSearch("")}
                            />
                          )}
                        </div>
                      </Col>
                      <Col xs={24} lg={9}>
                        <div className="d-flex flex-wrap justify-content-lg-end align-items-center" style={{ gap: 8 }}>
                          <Tag
                            value={`Mostrando ${users.length} de ${totalUsers}`}
                            severity={users.length === totalUsers ? "info" : "warning"}
                          />
                          <Button
                            type="button"
                            label="Limpiar filtros"
                            icon="pi pi-filter-slash"
                            severity="secondary"
                            outlined
                            disabled={!globalSearch && statusFilter === "all" && roleFilter === "all"}
                            style={primeButtonStyle}
                            onClick={() => {
                              setGlobalSearch("");
                              setStatusFilter("all");
                              setRoleFilter("all");
                            }}
                          />
                        </div>
                      </Col>
                    </Row>
                  </div>

                  <div style={{ padding: 16 }}>
                    <Table
                      dataSource={users}
                      columns={columns}
                      loading={loading}
                      bordered
                      scroll={{ x: "max-content", y: 500 }}
                      pagination={{
                        pageSize: 10,
                        showSizeChanger: true,
                        pageSizeOptions: ["10", "20", "50"],
                        showTotal: (total, range) => `${range[0]}-${range[1]} de ${total}`,
                      }}
                      locale={{ emptyText: "No hay usuarios para los filtros seleccionados" }}
                      rowClassName={(_, index) => {
                        if (index % 2 === 0) {
                          return "";
                        } else {
                          return "";
                        }
                      }}
                      rowKey={(record) => record.idUserAuth}
                    />
                  </div>
                </div>
                {/* /.card */}
              </div>
              {/* /.col-md-6 */}
            </div>
            {/* /.row */}
          </div>
          {/* /.container-fluid */}
        </section>
        {/* /.content */}
      </div>
      {/*----------------- MODAL-------------------- */}
      <div className="modal fade" id="modal-lg">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <div className="login-logo" style={{ color: "#0B3688" }}>
                Registro de Usuario
              </div>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <Registro
                open={visibleModalNuevo}
                onClose={() => setVisibleModalNuevo(false)}
              />
            </div>
          </div>
          {/* /.modal-content */}
        </div>
        {/* /.modal-dialog */}
      </div>
      {/*----------------- MODAL EDITAR----------------- */}
      <div className="modal fade" id="modal-lg-edit">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <EditarUsuario
              open={visibleModalEditar}
              onClose={() => setVisibleModalEditar(false)}
              datosUsuario={usuario}></EditarUsuario>
          </div>
          {/* /.modal-content */}
        </div>
        {/* /.modal-dialog */}
      </div>
      <Dialog
        visible={visibleModalImportar}
        onHide={() => {
          setVisibleModalImportar(false);
          resetExcelImport();
        }}
        header={
          <div className="d-flex align-items-center">
            <span
              className="d-inline-flex align-items-center justify-content-center mr-2"
              style={{
                width: 34,
                height: 34,
                borderRadius: 6,
                backgroundColor: "#e8f5e9",
                color: "#2e7d32",
              }}
            >
              <i className="fas fa-file-excel"></i>
            </span>
            <span>Importar usuarios desde Excel</span>
          </div>
        }
        modal
        draggable={false}
        style={{ width: "780px", maxWidth: "95vw" }}
        contentStyle={{ paddingTop: 12 }}
      >
        <div>
          <div
            className="d-flex justify-content-between align-items-center mb-3"
            style={{
              gap: 12,
              borderBottom: "1px solid #e9ecef",
              paddingBottom: 14,
            }}
          >
            <div>
              <div className="font-weight-bold">Plantilla oficial</div>
              <small className="text-muted">
                Usa las columnas requeridas para evitar errores de importacion.
              </small>
            </div>
            <Button
              type="button"
              label="Descargar plantilla"
              icon="pi pi-download"
              severity="success"
              outlined
              style={primeButtonStyle}
              onClick={descargarPlantillaExcel}
            />
          </div>

          <div
            className="mb-3"
            style={{
              border: "1px dashed #9cc7a2",
              borderRadius: 8,
              backgroundColor: "#fbfffb",
              padding: 18,
            }}
          >
            <label className="font-weight-bold d-block mb-2">
              <i className="fas fa-upload mr-2 text-success"></i>
              Seleccionar archivo
            </label>
            <FileUpload
              ref={excelInputRef}
              mode="basic"
              chooseLabel="Seleccionar archivo"
              chooseOptions={{ icon: "pi pi-upload", className: "p-button-success" }}
              accept=".xlsx"
              maxFileSize={10000000}
              customUpload
              onSelect={ExcelAJSON}
            />
            {excelFileName && (
              <div className="mt-2 text-muted">
                <i className="fas fa-paperclip mr-2"></i>
                {excelFileName}
              </div>
            )}
          </div>

          <div className="row mb-3">
            <div className="col-md-3 mb-2">
              <div className="border rounded p-3 h-100">
                <small className="text-muted d-block">Total filas</small>
                <span className="h4 mb-0">{excelTotalRows}</span>
              </div>
            </div>
            <div className="col-md-3 mb-2">
              <div className="border rounded p-3 h-100" style={{ borderColor: "#c8e6c9" }}>
                <small className="text-success d-block">Nuevos</small>
                <span className="h4 mb-0 text-success">{excelNewCount}</span>
              </div>
            </div>
            <div className="col-md-3 mb-2">
              <div className="border rounded p-3 h-100" style={{ borderColor: "#ffe0b2" }}>
                <small className="text-warning d-block">Actualizar</small>
                <span className="h4 mb-0 text-warning">{excelUpdateCount}</span>
              </div>
            </div>
            <div className="col-md-3 mb-2">
              <div className="border rounded p-3 h-100" style={{ borderColor: "#ffcdd2" }}>
                <small className="text-danger d-block">Errores</small>
                <span className="h4 mb-0 text-danger">{excelErrors.length}</span>
              </div>
            </div>
          </div>

          {excelErrors.length > 0 && (
            <div className="mb-3">
              <div className="alert alert-danger d-flex align-items-center mb-2" style={{ borderRadius: 6 }}>
                <i className="fas fa-exclamation-circle mr-2"></i>
                <span>Se encontraron filas con errores. Solo se importaran los registros validos.</span>
              </div>
              <div
                style={{
                  maxHeight: 190,
                  overflowY: "auto",
                  border: "1px solid #f5c6cb",
                  borderRadius: 6,
                  backgroundColor: "#fffafa",
                  padding: 12,
                }}
              >
                <ul className="mb-0 pl-3 text-danger">
                  {excelErrors.map((error, index) => (
                    <li key={index}>{error}</li>
                  ))}
                </ul>
              </div>
            </div>
          )}

          {excelPreviewRows.length > 0 && (
            <div className="mb-3">
              <div className="font-weight-bold mb-2">Previsualizacion</div>
              <div style={{ maxHeight: 220, overflowY: "auto", border: "1px solid #e9ecef", borderRadius: 6 }}>
                <table className="table table-sm mb-0">
                  <thead className="thead-light">
                    <tr>
                      <th>Fila</th>
                      <th>Documento</th>
                      <th>Correo</th>
                      <th>Estado</th>
                      <th>Detalle</th>
                    </tr>
                  </thead>
                  <tbody>
                    {excelPreviewRows.map((row) => (
                      <tr key={row.row}>
                        <td>{row.row}</td>
                        <td>{row.nroDoc}</td>
                        <td>{row.email}</td>
                        <td>
                          <Tag
                            value={row.status === "new" ? "Nuevo" : row.status === "update" ? "Actualizar" : "Error"}
                            severity={row.status === "new" ? "success" : row.status === "update" ? "warning" : "danger"}
                          />
                        </td>
                        <td>{row.message}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          <div
            className="d-flex justify-content-end pt-3"
            style={{ gap: 8, borderTop: "1px solid #e9ecef" }}
          >
            <Button
              type="button"
              label="Cancelar"
              icon="pi pi-times"
              severity="secondary"
              outlined
              style={primeButtonStyle}
              onClick={() => {
                setVisibleModalImportar(false);
                resetExcelImport();
              }}
            />
            <Button
              type="button"
              label={`Importar ${excelValidUsers.length} registros validos`}
              icon="pi pi-file-import"
              severity="success"
              disabled={excelValidUsers.length === 0}
              style={primeButtonStyle}
              onClick={importarRegistrosValidos}
            />
          </div>
        </div>
      </Dialog>
      <Toast ref={myToast} />
    </>
  );
  return usuarios;
}
